<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.document_type, 'Tip document')"
      :items="documentTypes"
      item-title="name"
      name="document_type"
      item-value="id"
      v-model="selectedDocumentType"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, toRefs, watch} from 'vue';
import {useTravelStore} from '~/plugins/store/travel';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {DocumentType} from '~/types/Travel';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => DocumentType | null,
      default: () => null,
      required: false
    },
    customerIndex: Number as () => number | null,
  },
  emits: ['update:modelValue', 'validation-customer-status'],
  setup(props, {emit}) {
    const {modelValue, customerIndex} = toRefs(props);
    const travelStore = useTravelStore();
    const translationStore = useTranslationStore();
    const selectedDocumentType = ref(modelValue.value ? modelValue.value : null);
    const documentTypes = ref<DocumentType[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);

    onMounted(async () => {
      documentTypes.value = await travelStore.getDocumentTypeList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;
      const isValid = !!selectedDocumentType.value;
      emit('validation-customer-status', {
        field: customerIndex.value !== null ? `document_type-${customerIndex.value}` : 'document_type',
        isValid
      });

      // Listen for validate events
      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `document_type-${customerIndex.value}` || data.detail === 'document_type')) {
        const isValid = !!selectedDocumentType.value;
        if (!isValid) {
          error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
        } else {
          error.value = [];
        }
        emit('validation-customer-status', {
          field: data.detail,
          isValid
        });
      }
    };

    watch(selectedDocumentType, (newDocumentType) => {
      if (initialSetupDone) {
        emit('update:modelValue', newDocumentType);
      }
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue) {
        selectedDocumentType.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-customer-status', {
        field: customerIndex.value !== null
            ? `document_type-${customerIndex.value}` : 'document_type', isValid
      });
    });

    return {
      selectedDocumentType,
      translationList,
      translation,
      documentTypes,
      error
    };
  },
});
</script>

<style scoped>
</style>